
import { useRefreshTrigger } from '~/mixins/gsap'

export default {
  mixins: [useRefreshTrigger],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initAnimation()
    })
  },
  methods: {
    initAnimation() {
      const gsap = this.$gsap

      const TL1 = gsap.timeline({
        scrollTrigger: {
          scrub: 0.5,
          start: '-130%',
          end: 'top',
          trigger: '#sections-logos',
        },
      })

      TL1.from('.case-logos', {
        alpha: 0,
        duration: 0.35,
        stagger: 0.15,
        ease: 'Power3.easeInOut',
      })

      TL1.from(this.$refs.text, {
        alpha: 0,
        duration: 0.35,
        ease: 'Power3.easeInOut',
      })
    },
  },
}
